import { Fragment, useEffect, useRef, useState } from 'react';
import { Oval } from "react-loader-spinner";
import { connect, useDispatch, useSelector } from "react-redux";
import { NavLink, Route, Routes, useNavigate, Navigate } from 'react-router-dom';
import { loaderActions } from './_actions/loader.actions';
import { Alert } from './_helpers/Alert';
import { Modal } from './_helpers/Modal';
import { AgentStatus } from './_constants/agent.constant';
import Department from './components/admin/department&role/Department';
import Rolerights from './components/admin/rolerights/Rolerights';
import Useradd from './components/admin/usermaster/partial/Useradd';
import Userlist from './components/admin/usermaster/Userlist';
import Userrights from './components/admin/userrights/Userrights';
import { getcountrystatecity, getuserprofileimagebyid } from './components/commonClass/CommonFunctions';
import { ClearLocalStorage, GetLocalStorage } from './components/commonClass/Session';
import SupplierList from './components/master/supplierManagement/SupplierList';
import SupplierManagement from './components/master/supplierManagement/SupplierManagement';
import FlightBookings from './pages/AllBookings/Flights/FlightBookings';
import HolidayBookings from './pages/AllBookings/Holidays/HolidayBookings';
import HotelBookings from './pages/AllBookings/Hotels/HotelBookings';
import { getTravellerCategory } from './pages/AllBookings/partial/bookingUtils';
import CorporateManagement from './pages/CorporateManagement/CorporateManagement';
import CorporateList from './pages/CorporateManagement/partial/CorporateList';
import CreateCorporate from './pages/CorporateManagement/partial/CreateCorporate';
import CorporateAssigneeManagement from './pages/CorporateManagement/querymanagement/CorporateAssigneeManagement';
import CorporateQueryCreate from './pages/CorporateManagement/querymanagement/CorporateQueryCreate';
import CorporateQueryLog from './pages/CorporateManagement/querymanagement/CorporateQueryLog';
import Dashboard from './pages/dashboard/Dashboard';
import CreateTravelerProfile from './pages/profile/CreateTravelerProfile';
import TravelerProfileList from './pages/profile/TravelerProfileList';
import HolidayAssigneeManagement from './pages/querymanagement/holiday/HolidayAssigneeManagement';
import HolidayQueryLog from './pages/querymanagement/holiday/HolidayQueryLog';
import CreateQuery from './pages/querymanagement/holiday/QueryCreate';
import CreateTravelAgent from './pages/TravelAgentManagement/partial/CreateTravelAgent';
import TravelAgentList from './pages/TravelAgentManagement/partial/TravelAgentList';
import TAAssigneeManagement from './pages/TravelAgentManagement/querymanagement/TAAssigneeManagement';
import TAQueryCreate from './pages/TravelAgentManagement/querymanagement/TAQueryCreate';
import TAQueryLog from './pages/TravelAgentManagement/querymanagement/TAQueryLog';
import TravelAgentLayout from './pages/TravelAgentManagement/TravelAgentManagement';
import { getAllData, postUsersData, verifytoken } from './services/ApiCallingUserServices';
import HotelList from './pages/MakeBooking/ListScreen/Hotels/HotelList';
import FlightList from './pages/MakeBooking/ListScreen/Flights/FlightList';
import FlightDetails from './pages/MakeBooking/ProccedBooking/Flights/FlightDetails';
import HotelsDetails from './pages/MakeBooking/DetailScreen/Hotels/HotelsDetails';
import HotelsDetailsReview from './pages/MakeBooking/ProccedBooking/Hotels/HotelsDetailsReview';
import Onboarding from './pages/NewLoginScreen/Onboarding';

const App = (props: any) => {
    const dispatch = useDispatch();
    const alertness = useSelector((store: any) => store.alertMess)
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false)
    const [show, setShow] = useState(0);
    const [MenuItem, setMenuItem] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [username, setUsername] = useState('');
    const [ProfileImage, setProfileImage] = useState<null | string>(null);
    const isBlank = ["", null, undefined];
    const [isImageError, setIsImageError] = useState(false)
    const otherPagePath = [
        "/Useradd",
        "/createquery",
        "/supplier-management",
        "/travel-agent-management/create-agent",
        "/corporate-management/add-corporate",

        "/hotel/details",
        "/hotel/review",
        "/hotel/payment",
        "/hotel/on-hold",
        "/hotel/Booking-successful",
        "/hotel/failed",
        "/hotel/pending",

        "/flight/review",
        "/flight/payment",
        "/flight/in-process",
        "/flight/failed",
        "/flight/pending",
    ]

    function findMenuPath(menuItems: any) {
        const targetPath = window?.location?.pathname
        for (const item of menuItems) {
            if (item.pageLink === targetPath) {
                return [item];
            }
            if (item.children && Array.isArray(item.children)) {
                const result: any = findMenuPath(item.children);
                if (result.length > 0) {
                    return [item, ...result];
                }
            }
        }

        return [];
    }

    const getMenuItem = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userdata: any = GetLocalStorage()
            let UserId = userdata?.userMasterID;
            let UserType = 3;
            const MenuItem = await postUsersData("/auth/v1/getmoallmenuitem", { UserId, UserType });
            dispatch({ type: "MENUITEMS", menu: findMenuPath(MenuItem?.data) });
            setMenuItem(MenuItem.data);
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
    }

    const handleClick = () => {
        setMenuOpen(menuOpen => !menuOpen);
    }

    const submenutoggle = useRef(null);

    const handleShow = (e: any, atr: any, menutype: any) => {
        if (e.currentTarget !== undefined) {
            if (menutype === 0) {
                e.currentTarget.classList.add("isactive");
                setShow(atr)
                setToggle(!toggle);
                scrollDown(atr);

                let element = document.getElementsByClassName('submenutoggle');
                const arr = Array.from(element);
                arr.forEach(element => element.classList.add('collapsed'));
                let elementsub = document.getElementsByClassName('submenutoggles');
                const arr1 = Array.from(elementsub);
                arr1.forEach(element => element.classList.add('collapse'));
                arr1.forEach(element => element.classList.remove('show'));
            }
            else if (menutype === 2) {
                e?.currentTarget?.classList?.add("isactive");
                setShow(atr)
                setToggle(!toggle);
                scrollDown(atr);

                let element = document.getElementsByClassName('submenutoggle');
                const arr = Array.from(element);
                arr.forEach(element => element.classList.add('collapsed'));
                let elementsub = document.getElementsByClassName('submenutoggles');
                const arr1 = Array.from(elementsub);
                arr1.forEach(element => element.classList.add('collapse'));
                arr1.forEach(element => element.classList.remove('show'));
            }
            else {

                let element = document.getElementsByClassName('isactive');
                const arr = Array.from(element);
                arr.forEach(element => element.classList.remove('isactive'));
                e.currentTarget.classList.toggle('collapsed');
                setShow(atr)
                setToggle(!toggle);
                scrollDown(atr);
            }
        }
    }

    const scrollDown = (reff: any) => {
        const submenu = document.getElementsByClassName(reff);
        const arr = Array.from(submenu);
        arr.forEach(element => element.classList.toggle('collapse'));
    }

    const handleLogout = () => {
        ClearLocalStorage();
        navigate('/');
    }

    const getUserById = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userdata: any = GetLocalStorage()
            let UserId = userdata?.userMasterID;
            if (!isBlank?.includes(userdata)) {
                setUsername(userdata?.userName);
            }
            await getAllData("/auth/v1/getuserrightsforvisibility?UserId=" + UserId).then((userdata) => {
                dispatch({ type: "USERDATA", tba: userdata.data });
            }
            );
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
    };

    const getuserprofileimagebyidData = async () => {
        const userProfileImageRole = await getuserprofileimagebyid();
        if (userProfileImageRole?.status) {
            setProfileImage(userProfileImageRole?.data?.[0]?.ImagePath ? `https://static-ethics.sgp1.digitaloceanspaces.com/etm/${userProfileImageRole?.data?.[0]?.ImagePath}` : null);
        }
        else {
            setProfileImage(null);
        }
        dispatch(loaderActions.end());
    }

    const getlocations = async () => {
        const countrystatecity = await getcountrystatecity();
        dispatch({ type: 'LOCATIONS', data: countrystatecity });
        dispatch(loaderActions.end());
    };

    useEffect(() => {
        getlocations();
    }, [])

    useEffect(() => {
        const allbookingpath = ["/holiday-bookings", "/flight-bookings", "/hotel-bookings"];
        if (!allbookingpath?.includes(window.location.pathname)) {
            for (let i = 1; i <= 5; i++) {
                localStorage.setItem(`tab-${getTravellerCategory(i)}`, '2');
            }
        }
        getUserById();
        getuserprofileimagebyidData();
        getMenuItem();
    }, [navigate]);

    const collectPageLinks = (menuItems: any) => {
        const links: any = [];
        function recurse(items: any) {
            for (const item of items) {
                if (item.pageLink) {
                    links.push(item.pageLink);
                }
                if (item.children && Array.isArray(item.children)) {
                    recurse(item.children);
                }
            }
        }
        recurse(menuItems);
        return links;
    }

    const [isOnboardingMode, setIsOnboardingMode] = useState(false);

    useEffect(() => {
        const userdata: any = GetLocalStorage();
        if (userdata && userdata.domainMasterId !== 1) {
            // StatusId: 1=Pending, 2=Submit, 3=Approved, 4=Rejected, 5=Re Submit
            const statusId = userdata?.statusId || userdata?.StatusId;
            if ([AgentStatus.Pending, AgentStatus.Submit, AgentStatus.Rejected].includes(statusId)) {
                setIsOnboardingMode(true);
                if (window.location.pathname !== '/onboarding') {
                    // Use TravelAgentId or CorporateId if available (handle both PascalCase and camelCase), fallback to userMasterID
                    const TravelAgentId = userdata?.TravelAgentId || userdata?.travelAgentId || userdata?.travalAgentId || "";
                    const CorporateId = userdata?.CorporateId || userdata?.corporateId || userdata?.TravelAgentId || userdata?.travelAgentId || userdata?.travalAgentId || "";

                    localStorage.setItem("taid", encodeURIComponent(TravelAgentId));
                    localStorage.setItem("coid", encodeURIComponent(CorporateId));

                    navigate('/onboarding', {
                        state: {
                            Id: TravelAgentId || CorporateId,
                            type: 'Edit',
                            viewtype: 'Update',
                            disabled: false,
                            editdisabled: true,
                            statusId: statusId,
                            itemData: { IsOnBoarding: 1 }
                        }
                    });
                }
            } else {
                setIsOnboardingMode(false);
            }
        } else {
            setIsOnboardingMode(false);
        }
    }, [navigate]);

    useEffect(() => {
        if (isOnboardingMode) {
            dispatch(loaderActions.end());
        }
    }, [isOnboardingMode]);

    useEffect(() => {
        if (MenuItem?.length > 0) {
            dispatch(loaderActions.end());
            if (!isOnboardingMode) {
                let y = false;
                let dash = MenuItem?.filter((x: any) => {
                    if (x.menuType === 0 && x.pageTitle === "Dashboard") return true;
                    else return false;
                });
                const collectPage = collectPageLinks(MenuItem)
                collectPage?.forEach((elemnt: any) => {
                    if (elemnt?.split('?')?.[0] === window.location.pathname) {
                        y = true;
                    }
                });
                otherPagePath?.forEach((elemnt: any) => {
                    if (elemnt === window.location.pathname) {
                        y = true;
                    }
                });
                if (y === false) {
                    if (dash?.length > 0) {
                        navigate("/dashboard");
                    } else {
                        navigate("/welcomepage");
                    }
                }
            }
        }
    }, [MenuItem, isOnboardingMode]);


    const dropdownrecurse = (mainindex: any, ele: any) => {
        return (
            <Fragment key={mainindex}>
                <div id={`sidenavAccordion${ele?.level}`}>
                    <NavLink data-bs-toggle="collapse" data-bs-target={`#collapsePages${ele?.menuId}`} aria-expanded="false" aria-controls={`collapsePages${ele?.menuId}`} className={`nav-link link_border master_link collapsed submenutoggle`} style={{ paddingLeft: `${1 + (ele?.level * 0.3)}rem` }} to="#" >
                        <div className="sb-nav-link-icon">
                            <i className="bi bi-grid" aria-hidden="true"></i>
                        </div>
                        {ele?.pageTitle}
                        <div className="sb-sidenav-collapse-arrow">
                            <i className="fa-solid fa-angle-down"></i>
                        </div>
                    </NavLink>
                    <div ref={submenutoggle} className={`${ele?.menuId} collapse submenutoggles`} id={`collapsePages${ele?.menuId}`} aria-labelledby="headingTwo" data-bs-parent={`#sidenavAccordion${ele?.level}`}>
                        {ele?.children?.map((oCol: any, childindex: any) =>
                            <>
                                {!oCol?.children && <nav className="sb-sidenav-menu-nested nav link_border" key={`childindex` + childindex}>
                                    <NavLink style={{ paddingLeft: `${1 + (oCol?.level * 0.3)}rem` }} className="nav-link border_gbg" to={oCol?.pageLink}>
                                        <div className="sb-nav-link-icon"><i className="bi bi-layers" aria-hidden="true"></i>
                                        </div>
                                        {oCol?.pageTitle}
                                    </NavLink>
                                </nav>}
                                {oCol?.children && dropdownrecurse(childindex, oCol)}
                            </>
                        )}
                    </div>
                </div>
            </Fragment>
        )
    }


    return (
        <>
            <Alert alert={alertness.isSuccess} alertmessage={alertness.isSuccessMessage} session={alertness.isSessionout} message={alertness.message} title={alertness.title} path={alertness.path} ></Alert>

            <div className='loaderModal'>
                <Modal show={props.load}>
                    <div className="loader">
                        <Oval
                            height={200}
                            width={200}
                            color="#122d59"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#122d59"
                            strokeWidth={3}
                            strokeWidthSecondary={3}


                        /></div>
                </Modal>
            </div>
            {isOnboardingMode ? (
                <div className="onboarding-screen div_bgcolor">
                    <nav className="sb-topnav navbar navbar-expand bg-white shadow-sm px-4 justify-content-between" style={{ height: '60px', position: 'fixed', width: '100%', zIndex: 1000 }}>
                        <img src='/assets/img/ETM-logo1.png' alt='ETM-logo' height="40px" />
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <a className="nav-link text-danger fw-bold cursor-pointer d-flex align-items-center gap-2" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                                    <i className="fa-solid fa-right-from-bracket"></i>
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="container-fluid booking_bg_color p-2" style={{ paddingTop: '70px' }}>
                        <div className='holiday_container'>
                            <Routes>
                                <Route path="/onboarding" element={<Onboarding />} />
                                <Route path="*" element={<Navigate to="/onboarding" replace />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`sb-nav-fixed ${(menuOpen ? 'sb-sidenav-toggled' : 'inactive')}`}>
                    <nav className="sb-topnav navbar navbar-expand">
                        <a className="navbar-brand ps-3"></a>
                        {/* <button className="btn btn-link btn-sm me-1 me-lg-0" onClick={handleClick} id="sidebarToggle"><i className="fa fa-bars" aria-hidden="true"></i></button> */}
                        <button className=" me-1 me-lg-0 border-0 bg-transparent sidebar_button" onClick={handleClick} id="sidebarToggle"><i className="fa-solid fa-2x fa-angle-left"></i></button>

                        {/* <ul className="navbar-nav ms-auto me-1 me-md-3 my-2 me-lg-3">
                        <a className="nav-link setc" role="button" onClick={handleLogout} data-bs-toggle="tooltip" data-bs-placement="left" title='Logout'><i className="fa fa-2x fa-sign-out" aria-hidden="true"></i></a>
                    </ul> */}
                        <ul className="navbar-nav ms-auto ms-md-auto me-3 me-lg-4 nav_drop">
                            <li className="nav-item dropdown nav_header">
                                <a className="nav-link dropdown-toggle nav_dropdown px-3"
                                //  id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                                >
                                    {
                                        ProfileImage && !isImageError ?
                                            <div className="profile_image">
                                                <img
                                                    loading='lazy'
                                                    src={ProfileImage}
                                                    alt="1"
                                                    onError={() => { setIsImageError(true) }}
                                                />
                                            </div>
                                            :
                                            <>
                                                <i className="fa-solid fa-circle-user"></i>
                                                {/* {
                                                ProfileShortName !== "" ?
                                                    <div className="profile_image">
                                                        {ProfileShortName}
                                                    </div>
                                                    :
                                                    <i className="fa-solid fa-circle-user"></i>
                                            } */}
                                            </>
                                    }

                                    <span className='ms-2 display_block' >{username}</span>
                                </a>
                                {/* <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item" onClick={handleLogout}>Logout</a></li>
                            </ul> */}
                            </li>
                        </ul>
                    </nav>
                    <div id="layoutSidenav">
                        <div id="layoutSidenav_nav">
                            <nav className="sb-sidenav accordion sb-sidenav-dark position-relative" id="sidenavAccordion">
                                <div className="sb-sidenav-menu">
                                    <div className="nav border_main">
                                        {MenuItem?.map((curElem: any, index: any) => {
                                            if (curElem?.seqNo === 0) {
                                                return (
                                                    <div key={index} className="sb-sidenav-menu-heading"><img className='d-flex mx-auto' src='/assets/img/ETM-logo1.png' alt='ETM-logo' width="50%" height="50px"></img></div>

                                                )
                                            }
                                            else {
                                                if (curElem?.menuType === 0) {
                                                    return (
                                                        <NavLink key={index} onClick={(e) => handleShow(e, curElem?.parentId, curElem?.menuType)} id={curElem?.parentId} className={`nav-link link_border align-items-center desh_link `} to="/dashboard">
                                                            <div className="sb-nav-link-icon">
                                                                <i className="fa-solid fa-gauge"></i>
                                                            </div>
                                                            {curElem?.pageTitle}
                                                        </NavLink>
                                                    )
                                                }
                                                else if (curElem?.children === null && curElem?.menuType === 2) {
                                                    return (
                                                        <NavLink key={index} onClick={(e) => { handleShow(e, curElem?.parentId, curElem?.menuType); }} className={`nav-link link_border align-items-center desh_link `} to={curElem?.pageLink}>
                                                            <div className="sb-nav-link-icon">
                                                                <i className="bi bi-layers" aria-hidden="true"></i>
                                                            </div>
                                                            {curElem?.pageTitle}
                                                        </NavLink>
                                                    )
                                                }
                                                else if (curElem?.children === null) {
                                                    return (
                                                        <NavLink key={index} onClick={(e) => { handleShow(e, curElem?.parentId, curElem?.menuType); }} className={`nav-link link_border master_link  ${(show === curElem?.parentId ? '' : 'collapsed')} `} to="#">
                                                            <div className="sb-nav-link-icon">
                                                                <i className="bi bi-grid" aria-hidden="true"></i>
                                                            </div>
                                                            {curElem?.pageTitle}
                                                            <div className="sb-sidenav-collapse-arrow">
                                                                <i className="fa-solid fa-angle-down"></i>
                                                            </div>
                                                        </NavLink>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <Fragment key={index}>
                                                            <NavLink data-bs-toggle="collapse" data-bs-target={`#collapsePages${curElem?.menuId}`} aria-expanded="false" aria-controls={`collapsePages${curElem?.menuId}`} className={`nav-link link_border master_link collapsed submenutoggle`} to="#" >
                                                                <div className="sb-nav-link-icon">
                                                                    <i className="bi bi-grid" aria-hidden="true"></i>
                                                                </div>
                                                                {curElem?.pageTitle}
                                                                <div className="sb-sidenav-collapse-arrow">
                                                                    <i className="fa-solid fa-angle-down"></i>
                                                                </div>
                                                            </NavLink>
                                                            <div ref={submenutoggle} className={`${curElem?.menuId} collapse submenutoggles`} id={`collapsePages${curElem?.menuId}`} aria-labelledby="headingTwo" data-bs-parent="#sidenavAccordion" >
                                                                {curElem?.children?.map((oCol: any, childindex: any) =>
                                                                    <>
                                                                        {!oCol?.children && <nav className="sb-sidenav-menu-nested nav link_border" key={childindex}>
                                                                            <NavLink className="nav-link border_gbg" to={oCol?.pageLink}>
                                                                                <div className="sb-nav-link-icon"><i className="bi bi-layers" aria-hidden="true"></i>
                                                                                </div>
                                                                                {oCol?.pageTitle}
                                                                            </NavLink>
                                                                        </nav>}
                                                                        {oCol?.children && dropdownrecurse(childindex, oCol)}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </Fragment>
                                                    )
                                                }
                                            }
                                        })}
                                    </div>
                                    <div className='nav border_main position-absolute w-100 bottom-0 mb-5'>
                                        <a className='nav-link border_gbg justify-content-center ps-0' onClick={handleLogout}><i className="fa-solid fa-right-from-bracket me-2"></i>Logout</a>
                                    </div>
                                </div>
                            </nav>
                        </div>

                        <div id="layoutSidenav_content" className='div_bgcolor'>
                            <div className="container-fluid booking_bg_color p-2">
                                <div className='holiday_container'>
                                    <Routes>
                                        <Route path="/dashboard" element={<Dashboard />} />
                                        <Route path="/onboarding" element={<Onboarding />} />
                                        <Route path='/Userlist' element={<Userlist />} />
                                        <Route path='/Useradd' element={<Useradd />} />
                                        <Route path='/Rolerights' element={<Rolerights />} />
                                        <Route path='/Userrights' element={<Userrights />} />
                                        <Route path='/Department' element={<Department />} />
                                        <Route path='/travelerprofilelist' element={<TravelerProfileList />} />
                                        <Route path='/createtravelerprofile' element={<CreateTravelerProfile />} />
                                        <Route path='/holidayquerylog' element={<HolidayQueryLog />} />
                                        <Route path='/createquery' element={<CreateQuery />} />
                                        <Route path='/holiday-assignee-management' element={<HolidayAssigneeManagement />} />
                                        <Route path='/supplier-list' element={<SupplierList />} />
                                        <Route path='/supplier-management' element={<SupplierManagement />} />

                                        <Route path='/travel-agent-management' element={<TravelAgentLayout />} >
                                            <Route index element={<TravelAgentList />} />
                                            <Route path='create-agent' element={<CreateTravelAgent />} />
                                        </Route>
                                        <Route path='/corporate-management' element={<CorporateManagement />} >
                                            <Route index element={<CorporateList />} />
                                            <Route path='add-corporate' element={<CreateCorporate />} />
                                        </Route>
                                        <Route path='/holiday-bookings' element={<HolidayBookings />} />
                                        <Route path='/flight-bookings' element={<FlightBookings />} />

                                        <Route path="/hotel/search" element={<HotelList />} />
                                        <Route path="/hotel/details" element={<HotelsDetails />} />
                                        <Route path="/hotel/*" element={<HotelsDetailsReview />} />


                                        <Route path="/flights/search" element={<FlightList />} />
                                        <Route path="/flight/*" element={<FlightDetails />} />

                                        <Route path='/hotel-bookings' element={<HotelBookings />} />
                                        <Route path='/ta-querylog' element={<TAQueryLog />} />
                                        <Route path='/ta-assignee-management' element={<TAAssigneeManagement />} />
                                        <Route path='/ta-querycreate' element={<TAQueryCreate />} />
                                        <Route path='/corporate-querylog' element={<CorporateQueryLog />} />
                                        <Route path='/corporate-assignee-management' element={<CorporateAssigneeManagement />} />
                                        <Route path='/corporate-querycreate' element={<CorporateQueryCreate />} />
                                    </Routes>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
function mapState(state: any) {
    const { load } = state.loader;
    return { load };
}
const APP = connect(mapState)(App);
export default APP;